import types from '../types/costs'
import {Map, List} from 'immutable'

const initialCosts = List()

function costs(state = initialCosts, action) {
  switch (action.type) {
    case types.FETCH_SUCCESS:
      return List(action.payload.costs)
    default:
      return state
  }
}

const initialRoot = Map({
  open: false,
  isFetching: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_OPEN:
      return state.set('open', action.payload.open)
    case types.FETCH:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.FETCH_SUCCESS:
      return state.merge({
        isFetching: false,
        error: '',
      })
    case types.FETCH_FAIL:
      return state.merge({
        isFetching: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

export default function(state, action) {
  const m = Map({
    costs: costs(state ? state.get('costs') : undefined, action),
  })
  return root(state, action).merge(m)
}



// WEBPACK FOOTER //
// ./src/sections/yours/reducers/costs.js